export const SET_PERMISSION = 'SET_PERMISSION';
export const SET_ACCESS_LIST = 'SET_ACCESS_LIST';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_PREFERENCE = 'SET_PREFERENCE';
export const SET_JOURNEY = 'SET_JOURNEY';
export const SET_SEAT_EXPIRED = 'SET_SEAT_EXPIRED';
export const CLEAR_ALL = 'CLEAR_ALL';